<template>
  <div v-if="ready" class="root" :class="{ 'bg-red': active, disabled: disable }">
    <div class="main-box">
      <div class="order" @click="selectOrder">
        <div class="index" :class="{ disabled: disable }">
          {{ item1.orderIndex + 1 }}
        </div>
        <div class="main">
          <div class="address-box">
            <div class="status">
              {{ orderInfo.routeStatus | enumTransfer(routeDetailOpts) }}-{{
                orderInfo.number
              }}人 &nbsp;
            </div>
            <div class="address">{{ item1.isShunt ? "（分流点）" : "" }} {{ item1.address }}</div>
          </div>
          <div class="detail">
            <div>{{ item1.showTime }}</div>

            <div v-if="isPick">
              <span :class="{ red: item1.isArriveWarning }">出发：{{ item1.arriveTime | toMintues }}</span>
            </div>
            <div v-else>
              <span style="margin-right: 20px">出发：{{ item2.arriveTime | toMintues }}</span>
              <span>到达：{{ item1.arriveTime | toMintues }}</span>
            </div>

            <div v-if="isPick" class="wait-time">
              <span>等候</span>
              <i class="el-icon-remove-outline" @click.stop="setWaitTime(false)"></i>
              <span class="minutes">{{ item1.waitTime / 60 }}分钟</span>
              <i class="el-icon-circle-plus-outline" @click.stop="setWaitTime(true)"></i>
            </div>

            <span>直达时间:
              {{
                (item1.navTotalDuration + item1.shuntDuration + item2.shuntDuration) | timeFilter
              }}</span>
          </div>

          <div v-if="orderInfo.routeStatus !== 5">
            <span style="margin-right: 20px">全时：{{
              (item1.totalDuration + item1.shuntDuration + item2.shuntDuration) | timeFilter
            }}
              &nbsp;-&nbsp; 标时:
              {{
                (item1.standardDuration + item1.shuntDuration + item2.shuntDuration) | timeFilter
              }}
              = {{ (item1.totalDuration - item1.standardDuration) | timeFilter }}</span>
            <span :class="{ red: item1.isDurationWarning }" v-if="item1.isDurationWarning">超标准: {{ item1 |
              calcExceedDuration(false) | timeFilter }}</span>
          </div>

          <div v-if="orderInfo.routeStatus === 5">
            <span style="margin-right: 20px">全时（规划）：{{
              (item1.totalDurationOnStart + item1.shuntDuration + item2.shuntDuration)
              | timeFilter
            }}
              &nbsp;-&nbsp; 标时:
              {{
                (item1.standardDuration + item1.shuntDuration + item2.shuntDuration) | timeFilter
              }}
              = {{ (item1.totalDurationOnStart - item1.standardDuration) | timeFilter }}</span>
            <span :class="{ red: item1.isDurationWarning }" v-if="item1.isDurationWarning">超标准: {{ item1 |
              calcExceedDuration(true) | timeFilter }}</span>
          </div>

          <div>
            <span>首次约定时间:
              {{ item1.firstPlanPickTime ? item1.firstPlanPickTime : " 未约定" }}</span>
            <span class="margin-left">实际{{ isPick ? "上车" : "下车" }}时间：{{ item1.actTime }}</span>
          </div>
          <div v-if="item1.actTotalDuration">
            <span v-if="item1.actWaitDuration || item1.actWaitDuration === 0">实际等待时间：{{ item1.actWaitDuration |
              timeFilter }}</span>
            <span v-if="item1.actTotalDuration" class="margin-left">实际行程时间：{{
              (item1.actTotalDuration + item1.shuntDuration + item2.shuntDuration) | timeFilter
            }}</span>

            <el-dropdown v-if="orderInfo.routeStatus === 5" style="margin-left: 20px"
              @command="(command) => orderItemAppealedFun(item1.orderId, command)">
              <el-button type="text">
                免责<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="2-1">时长免责</el-dropdown-item>
                <el-dropdown-item command="7-1">准点免责</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-if="routePlan.k1Delay || routePlan.k1Delay === 0">
            <span>上高速晚点：{{ item1.k1Delay }}</span>
            <span class="margin-left">下高速晚点：{{ routePlan.k2Delay }}</span>
            <span v-if="!isPick" class="margin-left">送晚点：<template v-if="item1.actTime">{{
              item1.actTime | timeDiff(item1.arriveTime)
                }}</template><template v-else>0</template></span>
            <span v-if="!isPick" class="margin-left">总计晚点：{{ item1.totalDelayDuration }}</span>

            <el-popover v-if="item1.totalDelayDuration" placement="bottom" width="400" trigger="click"
              popper-class="delay-popover">
              <div>
                <div>
                  <span>预计上高速时间：{{ (item1.k1PlanTime || routePlan.k1PlanTime) | toMintues }}</span>
                  <span class="margin-left">实际上高速时间：{{ routePlan.k1ActTime | toMintues }}</span>
                </div>

                <div style="margin-top: 8px">
                  <span>预计下高速时间：{{ routePlan.k2PlanTime | toMintues }}</span>
                  <span class="margin-left">实际下高速时间：{{ routePlan.k2ActTime | toMintues }}</span>
                </div>

                <div style="margin-top: 8px" v-if="routePlan.allowStayDuration">
                  <span>服务区停留时间：{{ routePlan.allowStayDuration }}</span>
                </div>
              </div>
              <el-button slot="reference" type="text" @click.stop
                style="color: #409eff; cursor: pointer; padding: 0; margin-left: 20px">
                详情
              </el-button>
            </el-popover>
          </div>
        </div>

        <div v-if="item1.isThing" class="huo bag">货</div>
        <div v-if="item1.isShunt" class="fen bag">分</div>
      </div>

      <div class="op-box" v-if="item1.shuntDuration">
        <span><i class="el-icon-warning-outline"></i></span>
        <span>分流路程时长 {{ item1.shuntDuration | timeFilter }} / {{ item1.shuntMiles | mileFilter
        }}{{ item1 | toShuntCallTime(isPick) }}</span>
      </div>
    </div>
    <div v-handle class="drag-handle">
      <i class="el-icon-rank"></i>
    </div>
  </div>
</template>

<script>
import { ElementMixin, HandleDirective } from "vue-slicksort";
import { mapState } from "vuex";
import moment from "moment";
import { orderItemAppealed } from "@/api";
export default {
  mixins: [ElementMixin],
  directives: {
    handle: HandleDirective
  },

  props: {
    orderMap: Object,
    routePlan: Object,
    orderId: [Number, String],
    index: Number,
    isPick: Boolean,
    onClick: Function,
    active: Boolean,
    disable: Boolean,
    onUpdate: Function
  },

  filters: {
    toMintues(val) {
      if (val && val.length) {
        return val.substr(11, 5);
      }
      return val;
    },

    calcExceedDuration(item1, finishedOrder) {
      let val = item1.totalDuration - item1.standardDuration - item1.maxLimitExceedDuration;
      if (finishedOrder) {
        val = item1.totalDurationOnStart - item1.standardDuration - item1.maxLimitExceedDuration;
      }
      return val > 0 ? val : 0;
    },

    toShuntCallTime(item, isPick) {
      if (isPick) {
        const callTime = moment(item.arriveTime).subtract(item.shuntDuration + 10 * 60, "seconds");
        var str = callTime.format("YYYY-MM-DD HH:mm:ss").substr(11, 5);
        return `，请在${str}安排分流车辆`;
      } else {
        return "";
      }
    },

    timeDiff(val1, val2) {
      // val2 是 yyyy-MM-dd HH:mm:ss的格式
      const actTime = moment(val2);
      // val1 是HH:mm的格式
      const planTime = moment(val2.substr(0, 11) + " " + val1 + ":00");
      // 返回正负值：正数表示实际时间晚于计划时间，负数表示实际时间早于计划时间
      return planTime.diff(actTime, "minutes");
    }
  },

  computed: {
    ...mapState({
      routeDetailOpts: (state) => state.enumMap["ROUTE_DETAIL_STATUS"]
    }),

    orderInfo() {
      return this.orderMap && this.orderId != null && this.orderMap[this.orderId];
    },

    item1() {
      const rp = this.routePlan;
      if (!rp || this.orderId == null) return undefined;
      const list = this.isPick ? rp.pickOrderList : rp.sendOrderList;
      if (!Array.isArray(list)) return undefined;
      return list.find((t) => t && t.orderId === this.orderId);
    },

    item2() {
      const rp = this.routePlan;
      if (!rp || this.orderId == null) return undefined;
      const list = this.isPick ? rp.sendOrderList : rp.pickOrderList;
      if (!Array.isArray(list)) return undefined;
      return list.find((t) => t && t.orderId === this.orderId);
    },

    ready() {
      return !!(this.item1 && this.item2 && this.orderInfo && this.routePlan);
    }
  },

  data() {
    return {};
  },

  methods: {
    selectOrder() {
      this.onClick(this.item1);
    },

    setWaitTime(isPlus) {
      if (this.item1.waitTime <= 0 && !isPlus) {
        return;
      }
      let value = isPlus ? this.item1.waitTime + 300 : this.item1.waitTime - 300;
      if (value < 0) {
        value = 0;
      }
      const data = { ...this.item1, waitTime: value };
      this.onUpdate(data, this.index);
    },

    orderItemAppealedFun(orderId, type) {
      this.$confirm("确认免责吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        orderItemAppealed(orderId, type).then(() => {
          this.$message.success("免责成功");
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.root {
  display: flex;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  user-select: none;

  &.bg-red {
    background-color: #e8f5f5 !important;
  }

  &.disabled {
    background-color: #eee;
  }

  .drag-handle {
    width: 40px;
    border-left: 1px solid #ddd;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: move;
    background-color: #f4f4f4 !important;

    i {
      font-size: 24px;
    }
  }

  .main-box {
    flex: 1;
  }
}

.order {
  display: flex;
  align-items: center;
  width: 540px;
  padding: 6px 10px;
  position: relative;

  .index {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    justify-items: center;
    align-items: center;
    flex-direction: column;
    line-height: 30px;
    background-color: orange;
    color: #fff;
    margin-right: 10px;

    &.disabled {
      background-color: #999;
    }
  }

  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    >div {
      margin: 6px 0;
    }

    .address-box {
      display: flex;

      .address {
        flex: 1;
      }

      .status {
        font-weight: bold;
      }
    }

    .detail {
      display: flex;

      div {
        margin-right: 16px;
      }

      .wait-time {
        display: flex;
        align-items: center;

        .minutes {
          width: 44px;
          text-align: center;
        }

        i {
          cursor: pointer;
          font-size: 20px;
          margin: 0 3px;
          color: #999;
        }
      }
    }

    .route-time {
      font-size: 13px;
    }
  }

  .msg {
    margin-left: 20px;
    width: 30px;
    cursor: pointer;

    i {
      font-size: 30px;
    }
  }

  .bag {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    border-radius: 2px;
    text-align: center;
    line-height: 20px;
  }

  .fen {
    background-color: rgb(141, 141, 241);
    color: #fff;
  }

  .huo {
    background-color: rgb(248, 248, 134);
  }
}

.op-box {
  border-top: 1px solid #ddd;
  padding: 6px 10px;
  background-color: #f4f4f4;

  i {
    color: rgb(240, 128, 128);
    font-size: 16px;
    margin-right: 4px;
  }
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.margin-left {
  margin-left: 20px;
}
</style>
